import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./banner.css";
import htmlparser from "html-react-parser";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";

const imgCDNURL = process.env.REACT_APP_CDN_URL;

function scrollToSection() {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches; // Check if the screen width is greater than or equal to 1024px (adjust this value as needed)
    const navbarHeight = document.querySelector('nav').offsetHeight; // Get the height of the navigation bar
    const offset = 10; // Adjust this value to determine how much above the form the scroll will stop
    const sectionPosition = document.getElementById("Connect-With-Us").offsetTop - (isDesktop ? (navbarHeight + offset) : 0); // Adjust scroll position only for desktop
    window.scrollTo({
        top: sectionPosition,
        behavior: "smooth",
    });
}

export default function Banner({ BannerData, isMobile }) {

    return (
        <>
            <div className="banner">
                <Container className="bannercontainer">
                    <Row>
                        <Col sm={12} md={12} xl={12} lg={12}>
                            {isMobile && (
                                <UserWayAccessibilityMenu color="white" width={30} height={30} />
                            )}
                            <h1 className="tagline">{htmlparser(BannerData.Tagline)}</h1>
                            <h2 className="subtagline">{htmlparser(BannerData.subTagline)}</h2>

                            <div className="benifits">
                                <p className="benifitsheading">{htmlparser(BannerData.benifitsheading)}</p>
                                <ul style={{ listStyleType: "none" }}>
                                    {BannerData.benifitsLists.map((item, index) => (
                                        <li key={index} className="benifitslist">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
                                                <g clip-path="url(#clip0_722_121)">
                                                    <path d="M7.5655 22.4688C5.91696 18.0571 3.60043 14.302 0 11.2831C1.02344 10.7616 2.05608 10.6542 2.99372 11.1267C3.90378 11.5838 4.74337 12.2373 5.50942 12.9183C6.2387 13.5718 6.83622 14.3756 7.49196 15.115C8.45411 13.3939 9.3795 11.6666 10.3723 9.97928C12.0055 7.20282 13.7766 4.51839 16.1636 2.3187C16.8316 1.70205 17.613 1.18664 18.4066 0.738726C18.8448 0.493293 19.4209 0.48409 19.9939 0.46875C14.8981 7.22736 10.7247 14.4462 7.56243 22.4688H7.5655Z" fill="#FFDB5D" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_722_121">
                                                        <rect width="20" height="22" fill="white" transform="translate(0 0.46875)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>{' '}
                                            {htmlparser(item)}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <Button
                                className="bannerbtn"
                                onClick={() => {
                                    scrollToSection();
                                }}
                            >
                                Connect With Us
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
